import Blue from '~/core'

new Blue({
  name: 'JumpLink',
  selector: '.jump-link',
  setup(jumpLink) {
    const nav = jumpLink.querySelector('.jump-link__nav-inner')
    if (!nav) {
      return
    }

    const items = [...nav.querySelectorAll('.jump-link__item')]
    const destinations = items.map((i) => document.querySelector(i.getAttribute('href')))

    const activateLink = (activeSection) => {
      items.forEach((i) => i.classList.remove('is-active'))
      items.forEach((i) => {
        if (i.getAttribute('href') === `#${activeSection.getAttribute('id')}`) {
          i.classList.add('is-active')
          if (i.offsetLeft + i.offsetWidth > nav.offsetWidth) {
            nav.scrollBy({
              behavior: 'smooth',
              left: i.offsetLeft + i.offsetWidth - nav.offsetWidth,
            })
          } else {
            nav.scrollTo({
              behavior: 'smooth',
              left: 0,
            })
          }
        }
      })
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) activateLink(entry.target)
        })
      },
      {
        rootMargin: '-50% 0px',
      },
    )

    destinations.forEach((destination) => {
      if (destination !== null) {
        observer.observe(destination)
      }
    })

    items.forEach((i) =>
      i.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const destination = destinations.find((d) => i.getAttribute('href') === `#${d.getAttribute('id')}`)

        window.scrollBy({
          top: destination.getBoundingClientRect().top - jumpLink.offsetHeight,
          behavior: 'smooth',
        })
      }),
    )
  },
})
